jQuery(document).ready(function(){

  if(jQuery('#nos-partenaires').length > 0) {
    const breakpoints = {
      1200: {
        slidesPerView: 4
      },
      992: {
        slidesPerView: 3
      },
      768: {
        slidesPerView: 3
      },
      500: {
        slidesPerView: 1
      },
      0: {
        slidesPerView: 1
      }
    }
    new Swiper("#nos-partenaires .partenaires-top .slider-partenaires", {
      slidesPerView: 4,
      spaceBetween: 30,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      breakpoints: breakpoints,
    });

    new Swiper("#nos-partenaires .partenaires-bottom .slider-partenaires", {
      slidesPerView: 4,
      spaceBetween: 30,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
        reverseDirection: true
      },
      breakpoints: breakpoints,
    });
  }
})
